import React from "react";
import Navbar from "../../components/layout/Navbar";
import HomeSection from "./HomeSection";
import ConvenienceSection from "./ConvenienceSection";
import FeaturesSection from "./FeaturesSection";
import ThemeSection from "./ThemeSection";
import BundleSection from "./BundleSection";
import FAQSection from "./FAQSection";
import TestimonialSection from "./TestimonialSection";
import FABContactUs from "../../components/ui/FABContactUs";
import Footer from "../../components/layout/Footer";

const LandingPage = () => {
  return (
    <div>
      <Navbar />
      <HomeSection />
      <ConvenienceSection />
      <FeaturesSection />
      <ThemeSection />
      <BundleSection />
      <FAQSection />
      <TestimonialSection />
      <FABContactUs />
      <Footer />
    </div>
  );
};

export default LandingPage;
